import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import AboutStyle4 from '../About/AboutStyle4';
import FunFact from '../FunFact';
import AboutStyle5 from '../About/AboutStyle5';
import IconBoxStyle6 from '../IconBox/IconBoxStyle6';
import SectionHeadingStyle5 from '../SectionHeading/SectionHeadingStyle5';

import Marquee from '../Marquee';
import Brands from '../Brands';
import { pageTitle } from '../../helpers/PageTitle';

const funfactData = [
  { title: 'Active Deployments', number: '50+' },
  { title: 'Projects Delivered', number: '120+' },
  { title: 'Team Experts', number: '15+' },
  { title: 'Industries Served', number: '8+' },
];

const brandList = [
  { logoSrc: '/images/marketing-agency/brand_1.svg', logoAlt: 'Brand' },
  { logoSrc: '/images/marketing-agency/brand_2.svg', logoAlt: 'Brand' },
  { logoSrc: '/images/marketing-agency/brand_3.svg', logoAlt: 'Brand' },
  { logoSrc: '/images/marketing-agency/brand_4.svg', logoAlt: 'Brand' },
];

const brandListDark = [
  { logoSrc: '/images/marketing-agency/brand_1_dark.svg', logoAlt: 'Brand' },
  { logoSrc: '/images/marketing-agency/brand_2_dark.svg', logoAlt: 'Brand' },
  { logoSrc: '/images/marketing-agency/brand_3_dark.svg', logoAlt: 'Brand' },
  { logoSrc: '/images/marketing-agency/brand_4_dark.svg', logoAlt: 'Brand' },
];

export default function AboutPage({ darkMode }) {
  pageTitle('About — Ranads');

  return (
    <>
      <Spacing lg='70' md='70' />
      <Spacing lg='140' md='80' />

      <SectionHeadingStyle3
        title='Building systems that scale your ops, <br>and sharpen your growth'
        subTitle='About Ranads'
        variant='text-center'
        shape='shape_1'
      />

      <Spacing lg='75' md='60' />

      <AboutStyle4
        thumbnailSrc='/images/about/about3.avif'
        miniTitle='Company Info'
        title='We build CMS, ERP & WhatsApp API platforms'
        subTitle={`Ranads designs and ships production systems with React and NestJS, integrates the WhatsApp Business API, and embeds the latest LLM/AI workflows. 
We focus on clean architecture, real time analytics, and reliable automations so your content, sales, and operations move faster together.
Our brand colors are  expect a crisp UI, consistent DX, and pragmatic delivery from discovery to launch.`}
        btnText='See Our Services'
        btnUrl='/service'
      />

      <Spacing lg='125' md='70' />

      <div className='container'>
        <FunFact data={funfactData} />
      </div>

      <Spacing lg='125' md='70' />

      <AboutStyle5
        variant='cs_type_1'
        thumbnailSrc='/images/about/about.avif'
        miniTitle='What We Do'
        title='Systems that connect, automate, and grow with you'
        subTitle='From headless CMS and ERP modules to WhatsApp flows and AI copilots our builds are fast, maintainable, and ready for scale. We prioritize security, observability, and a delightful admin experience.'
        progressBarList={[
          { title: 'React & NestJS Engineering', percentage: '90' },
          { title: 'WhatsApp Business API & Automations', percentage: '95' },
          { title: 'AI/LLM Integrations & RAG', percentage: '85' },
        ]}
        salesTitle='Efficiency Gain'
        groth='30'
      />

      <Spacing lg='150' md='80' />

      <section className='cs_primary_bg'>
        <Spacing lg='140' md='70' />
        <div className='container'>
          <SectionHeadingStyle5 title='How we work' />
          <Spacing lg='85' md='45' />

          <div className='cs_working_process_wrap cs_center'>
            <div className='cs_working_process'>
              <div className='cs_working_process_col'>
                <IconBoxStyle6
                  bgSrc='/images/others/process_1.png'
                  iconSrc='/images/icons/search.svg'
                  title='Discover'
                  subTitle='Stakeholder interviews, system audit, and KPI definition. We map data models and user journeys before a single line of code.'
                />
              </div>
              <div className='cs_working_process_col'>
                <IconBoxStyle6
                  bgSrc='/images/others/process_2.png'
                  iconSrc='/images/icons/idea.svg'
                  title='Architect'
                  subTitle='Services, modules, and permissions designed for clarity and scale. We document flows, events, and APIs up front.'
                />
              </div>
              <div className='cs_working_process_col'>
                <IconBoxStyle6
                  bgSrc='/images/others/process_3.png'
                  iconSrc='/images/icons/gear.svg'
                  title='Build & Iterate'
                  subTitle='React frontends, NestJS services, WhatsApp flows, and LLM features delivered in sprints with CI/CD and observability.'
                />
              </div>
            </div>
          </div>
        </div>
        <Spacing lg='150' md='80' />
      </section>

      <Spacing lg='135' md='70' />

      <Marquee text='CMS • ERP • WhatsApp API • React • NestJS • LLM/AI • Dashboards • DevOps' />

      <Spacing lg='84' md='50' />

      {/* <div className='container'>
        <Brands data={darkMode ? brandListDark : brandList} />
      </div> */}

      <Spacing lg='135' md='80' />
    </>
  );
}
